import { makeStyles } from '@mui/styles'

const baseStyle = makeStyles(() => ({
  displayBrandBase: {
    height: '5.6vh',
    width: '14vw',
    minWidth: '5.65vh',
    display: 'flex',
    borderRadius: '20px',
    position: 'absolute',
    padding: '2px',
    top: '30px',
    left: '30px',
    alignItems: 'center',
    boxShadow: '5px 5px 15px rgba(255, 255, 255, 0.1)',
    background: 'rgba(255, 255, 255, 0.2)',
    borderRight: '1.5px solid rgba(0, 0, 0, 1)',
    borderBottom: '1.5px solid rgba(0, 0, 0, 1)',
    backdropFilter: 'blur(10px)',
  },
  logoText: {
    fontSize: '1.2vw',
    width: '14vw',
    textAlign: 'center',
    fontFamily: 'Syncopate, sans-serif',
    color: '#e2e2e2',
    letterSpacing: 1,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  logo: {
    height: '5vh',
    width: '5vh',
  },
}))

export default baseStyle
